import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import {
  exchangeSchoolYearPath,
  nextYearStudentsPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  createStudent,
  fetchNextClasses,
  FETCH_NEXT_CLASSES_SUCCESS_MESSAGE,
  CREATE_STUDENT_SUCCESS_MESSAGE,
  IStudentParam,
  fetchPlans,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import StudentForm from "../../../templates/manager/StudentForm";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const [fetched, setFetched] = React.useState({
    next_classes: false,
  });
  const { nextYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === FETCH_NEXT_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, next_classes: true }));
      }, 100);
    }
    if (state.success_message === CREATE_STUDENT_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(nextYearStudentsPath);
    }
  }, [history, dispatch, state.success_message]);

  const createStudentFunc = React.useCallback(
    (student: IStudentParam) => {
      dispatch(peep(createStudent(student)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchNextClasses(nextYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, nextYear]);

  React.useEffect(() => {
    dispatch(fetchPlans());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
          {
            title: `${titles.nextYearStudents} (${nextYear}年度)`,
            to: nextYearStudentsPath,
          },
        ]}
        currentTitle={`${titles.newNextYearStudent} (${nextYear}年度)`}
      />
      {fetched.next_classes && (
        <StudentForm
          title={`${titles.newNextYearStudent} (${nextYear}年度)`}
          calling={calling}
          next_classes={state.next_classes}
          error={state.error}
          school={state.manager.school!}
          isNextYear={true}
          upsertStudent={createStudentFunc}
          plans={state.plans}
        />
      )}
    </div>
  );
};
